import { Link } from "@tanstack/react-router";
import { Selo } from "@notes/ui";
import { Plug, Video, KeyRound, Users, ChevronRight, ShieldCheck } from "lucide-react";
import { Pagina, Secao } from "../shell/Shell.js";
import { usarPonte } from "../lib/api.js";
import { usePode } from "../shell/Sessao.js";

/**
 * O HUB de configurações, no molde do CRM: um cartão por assunto, com o estado
 * à vista. A pessoa que abre esta tela quer saber o que está ligado, não
 * navegar num menu de menus, então cada cartão diz em que pé está.
 */
export function Configuracoes() {
  const ponte = usarPonte();
  const podeGerirMembros = usePode("membros.gerir");
  const p = ponte.data?.ponte;
  const ligada = p?.status === "ativo" && p.temSegredo;

  const grupos: Array<{
    para: string; titulo: string; descricao: string; icone: typeof Plug; tom: string;
    estado?: React.ReactNode; oculto?: boolean;
  }> = [
    {
      para: "/configuracoes/ponte", titulo: "EnturOS CRM", tom: "ouro", icone: Plug,
      descricao: "A ponte com o CRM: as reuniões viram histórico na negociação, e a proposta enviada fecha a promessa sozinha.",
      estado: ponte.isLoading ? null : ligada
        ? <Selo tom="bom"><span aria-hidden className="sinal sinal-bom" />ligado{p?.crmTenantNome ? ` a ${p.crmTenantNome}` : ""}</Selo>
        : <Selo tom="atencao">não ligado</Selo>,
    },
    {
      para: "/gravar", titulo: "Gravação e aparelhos", tom: "verde", icone: Video,
      descricao: "Como a conversa entra: reunião on-line, extensão do navegador, telefone e áudio enviado à mão.",
    },
    {
      para: "/integracoes", titulo: "Chaves, webhooks e plano", tom: "roxo", icone: KeyRound,
      descricao: "Acesso de outros sistemas ao acervo, avisos assinados e o consumo do ciclo.",
    },
    {
      para: "/configuracoes/equipe", titulo: "Agência e equipe", tom: "cinza", icone: Users,
      descricao: "Quem participa, com que papel, e quem pode gravar.",
      oculto: !podeGerirMembros,
    },
  ];

  return (
    <Pagina titulo="Configurações" descricao="O que está ligado, e o que ainda falta ligar.">
      <Secao ordem={0}>
        <ul className="enotes-hub">
          {grupos.filter((g) => !g.oculto).map((g, i) => (
            <li key={g.para} className="surge" style={{ animationDelay: `${i * 45}ms` }}>
              <Link to={g.para} className="enotes-hub-cartao" data-tom={g.tom}>
                <span className="enotes-hub-icone" aria-hidden><g.icone size={17} /></span>
                <span className="enotes-hub-texto">
                  <span className="enotes-hub-titulo">
                    {g.titulo}
                    {g.estado}
                  </span>
                  <span className="enotes-hub-sub">{g.descricao}</span>
                </span>
                <ChevronRight size={16} aria-hidden className="enotes-hub-seta" />
              </Link>
            </li>
          ))}
        </ul>
      </Secao>

      <Secao titulo="Sobre a sua conta" ordem={1}>
        <div className="enotes-hub">
          <div className="enotes-hub-cartao" data-tom="cinza" data-estatico="sim">
            <span className="enotes-hub-icone" aria-hidden><ShieldCheck size={17} /></span>
            <span className="enotes-hub-texto">
              <span className="enotes-hub-titulo">Verificação em duas etapas</span>
              <span className="enotes-hub-sub">
                A chave do Notes é independente da do CRM, e quem tem uma é obrigado a ter a outra.
                A configuração fica no seu perfil, no menu da conta.
              </span>
            </span>
          </div>
        </div>
      </Secao>
    </Pagina>
  );
}
